import { FR_MONTHS } from "@/utils"
import { Loading } from "element-ui"

export const loaderMixin = {
  data() {
    return {
      _loader: null
    }
  },
  methods: {
    openLoader(target) {
      if (!target) throw new Error("No loader target was provided")

      if (!this._loader) {
        this._loader = Loading.service({
          target,
          fullscreen: false
        })
      }
    },
    closeLoader() {
      setTimeout(() => {
        if (this._loader) {
          this._loader.close()
        }
        this._loader = null
      }, 250)
    }
  }
}

/**
 * Single Month Plannings mixin
 */
export const smpMixin = {
  data() {
    return {
      currentSupport: null,
      isGroupPlanning: false,
      Videos: [],
      credits: 0,
      planningId: null
    }
  },
  methods: {
    handleSupportChange(support) {
      this.currentSupport = support
    },
    setCurrentData() {
      if (!this.currentSupport || !this.planning[this.currentSupport.id]) {
        this.Videos = []
        // this.credits = 0
        this.isGroupPlanning = false
        this.planningId = null
        return
      }
      const planning = this.planning[this.currentSupport.id]
      const Videos = []
      planning.videos.forEach(video => {
        Videos.push(video)
      })
      this.planningId = planning.id
      this.Videos = Videos
      // this.credits = planning.total_credit
      this.isGroupPlanning = !!+planning.use_group
    }
  },
  watch: {
    currentSupport: {
      handler: "setCurrentData",
      immediate: true
    }
  }
}

/**
 * Structures the response data sent back
 * by /api/plannings & /api/plannings/history?year
 * @param {Object} data - response data to structure
 *
 * @returns {Promise} - returns a promise that resolves
 * with an array planning data Structured by month,
 * each item in the array is a month,
 * order is the same as the one sent back.
 * each month is an object containing planning by support id.
 */
async function structurePlanningsData({ timeline, ...rest }) {
  const months = []
  for (const key in timeline) {
    const planningBySup = Object.entries(timeline[key])

    // set planning key and name
    const d = new Date(key)
    const month = {
      key,
      date: {
        month: FR_MONTHS[d.getMonth()],
        year: d.getFullYear()
      }
    }

    // each support planning is sent like this
    // { ':support_id': [{ ... }]}
    // we get destructure the [key, val] array and get
    // support and its respective Support planning
    planningBySup.forEach(([supID, [supPlanning]]) => {
      month[supID] = {
        id: supPlanning.id,
        videos: supPlanning.videos,
        ...rest[key][supID]
      }
    })
    months.push(month)
  }
  months.reverse()
  return months
}

export const planningMixin = {
  methods: {
    structurePlanningsData
  }
}
